module.exports = __webpack_public_path__ + "static/media/Header_Image_001_Tablet.46bcd6c1.png";